import {
  SET_USER,
  SET_PACKAGES,
  SET_PACKAGE,
  SET_PRODUCTS,
  SET_CURRENT_PRODUCT,
  SET_CART,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  UPDATE_CART_ITEM,
  CLEAR_CART
} from './mutation-types'
import _ from 'lodash'

export default {
  [SET_USER] (state, user) {
    state.currentUser = user
    state.isAuthenticated = !_.isUndefined(state.currentUser)
  },
  [SET_PACKAGES] (state, packages) {
    state.packages = packages
  },
  [SET_PACKAGE] (state, pkg) {
    state.currentPackage = pkg
  },

  // Product mutations
  [SET_PRODUCTS] (state, products) {
    state.products = products
  },
  [SET_CURRENT_PRODUCT] (state, product) {
    state.currentProduct = product
  },

  // Cart mutations
  [SET_CART] (state, cart) {
    state.cart = cart
  },
  [ADD_TO_CART] (state, item) {
    const existing = state.cart.find(i => i.variantId === item.variantId)
    if (existing) {
      existing.quantity += item.quantity
    } else {
      state.cart.push(item)
    }
  },
  [REMOVE_FROM_CART] (state, variantId) {
    state.cart = state.cart.filter(i => i.variantId !== variantId)
  },
  [UPDATE_CART_ITEM] (state, { variantId, quantity }) {
    const item = state.cart.find(i => i.variantId === variantId)
    if (item) {
      item.quantity = quantity
    }
  },
  [CLEAR_CART] (state) {
    state.cart = []
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js